export default {
	data () {
		return  {
			modals: {
                'modal-delete': {
                    box: ''
                }
            },
	    }
	},

	methods: {
        closeModal(modalName) {
            this.$bvModal.hide(modalName)
        },

        showAlertBox($type, $title, $msg) {
            this.$swal({
                width: '30%',
                icon: $type,
                title: $title,
                timer: 3500,
                html: $msg,
            })
        },

		findIndex(dataset, col, value) {
            return dataset.findIndex(function(x) {
                return x[col] == value
            })
        },

        isMobile() {
            let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
            if (width > 414) {
                return false
            } else {
                return true
            }
        },

        getImageUrl(sku, size, sequence, extension) {
            return '/storage/images/' + sku + '/' + sku + '_' + size + '_' + sequence + '.' + extension
        },

        scrollToElement(options, index) {
            this.$nextTick(() => {
                const el = this.$el.getElementsByClassName('index-' + index)[0];

                if (el) {
                    el.scrollIntoView(options);
                }
            })
        },

        camelToSnakeCase(text) {
            return text.replace(/(.)([A-Z][a-z]+)/, '$1_$2').replace(/([a-z0-9])([A-Z])/, '$1_$2').toLowerCase()
        },

        objFilter(data, keys_to_keep) {
            const redux = array => array.map(o => keys_to_keep.reduce((acc, curr) => {
                acc[curr] = o[curr];
                return acc
            }, {}))

            return redux(data)
        },

        calculateOpenOrders(lines) {
            let count = 0

            lines.forEach((row, idx, array) => {
                if (row.sale_order.status == 'Confirmed' || row.sale_order.status == 'Dispatched') {
                    count++
                }
            })

            return count
        },

        getDate() {
            return this.$moment().format('YYYY-MM-DD')
        },

        formatDateTimeToDate(date) {
            return this.$moment(date).format('YYYY-MM-DD')
        },

        getDateTime() {
            return this.$moment().format('YYYY-MM-DD HH:mm:ss')
        },

        numberWithCommas(num) {
            if (!num) {
                return '0.00'
            } else {
                return Number(num).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
        },

        sumOfCol(obj, col) {
            return obj.reduce((accumulator, current) => accumulator + current[col], 0)
        }
  	}
}
